
import Vue from "vue";
import filters from "@/filters";
import toast from "@/functions/toast.function";
import Component from "vue-class-component";
import getBrowserType from "@/functions/getBrowserType";

import { AxiosResponse } from "axios";
import { Action, State } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { SchoolTypeLevelEnum } from "@/constants/enum.constant";
import {
  CANDIDATE_LOGIN,
  COMPANY,
  SCHOOL_LOGIN,
  SUBDOMAIN,
} from "@/constants/portal.constant";

import AppHeader4 from "@/components/layout/AppHeader4.vue";
import AppHeader2 from "@/components/layout/AppHeader2.vue";
import AppHeader1 from "@/components/layout/AppHeader1.vue";

@Component({
  components: {
    AppHeader4,
    AppHeader2,
    AppHeader1,
  },
  filters,
})
export default class AppHeader extends Vue {
  @Action("login", { namespace: "school" })
  private schoolLogin: any;
  @Action("login", { namespace: "candidate" })
  private candidateLogin: any;
  @Action("login", { namespace: "company" })
  private companyLogin: any;
  @Action("request", { namespace: "school" })
  private schoolRequest: any;
  @Action("request", { namespace: "candidate" })
  private candidateRequest: any;
  @Action("request", { namespace: "company" })
  private companyRequest: any;

  @State("school", { namespace: "school" })
  private school!: any;

  @Prop({ default: 1 })
  private templateNumber!: number;

  private get isUniversity() {
    return this.school?.school_type.type === SchoolTypeLevelEnum.UNIVERSITY;
  }
  private get showAppLogin() {
    return this.$store.state.app_login;
  }
  private get getAppLoginTitle() {
    switch (this.$store.state.app_login) {
      case "school":
        return "Staff Admin";
      case "candidate":
        return `${this.isUniversity ? "Mahasiswa" : "Siswa"} & Alumni`;
      case "company":
        return "Perusahaan";
      default:
        return "Unknown";
    }
  }

  private email: string = "";
  private password: string = "";
  private isForgotPassword: boolean = false;

  private handleClickButton(route: any) {
    if (route === "candidate-register") {
      this.$router.push({ name: "register" });
    } else if (route === "candidate") {
      this.$store.state.app_login = "candidate";
    } else if (route === "company-register") {
      this.$router.push({ name: "partnership" });
    } else if (route === "company") {
      this.$store.state.app_login = "company";
    } else {
      this.$store.state.app_login = "school";
    }
  }

  private closeAppLogin() {
    if (this.isForgotPassword) this.isForgotPassword = false;
    else this.$store.state.app_login = null;
  }

  private submit() {
    console.log(this.email);
    if (!this.email) {
      toast.warning("The email field is required.");
      return;
    }
    if (!this.isForgotPassword) {
      if (!this.password) {
        toast.warning("The password field is required.");
        return;
      }
      if (!this.school.id) {
        toast.warning("The school id field is required.");
        return;
      }
    }
    switch (this.$store.state.app_login) {
      case "school":
        if (this.isForgotPassword)
          this.schoolRequest({
            params: {
              email: this.email.toLowerCase(),
              subdomain: SUBDOMAIN,
            },
          });
        else
          this.schoolLogin({
            params: {
              email: this.email.toLowerCase(),
              password: this.password,
            },
            success: (res: AxiosResponse) => {
              window.open(
                `${SCHOOL_LOGIN}?token=${res.data.data.token}`,
                getBrowserType() === "Mozilla Firefox" ? "_self" : "_blank"
              );
            },
          });
        break;
      case "candidate":
        if (this.isForgotPassword)
          this.candidateRequest({
            params: {
              email: this.email.toLowerCase(),
              subdomain: SUBDOMAIN,
            },
          });
        else
          this.candidateLogin({
            params: {
              email: this.email.toLowerCase(),
              password: this.password,
              school_id: this.school.id,
            },
            success: (res: AxiosResponse) => {
              window.open(
                `${CANDIDATE_LOGIN}?token=${res.data.data.token}`,
                getBrowserType() === "Mozilla Firefox" ? "_self" : "_blank"
              );
            },
          });
        break;
      case "company":
        if (this.isForgotPassword)
          this.companyRequest({
            params: {
              email: this.email.toLowerCase(),
              subdomain: SUBDOMAIN,
            },
          });
        else
          this.companyLogin({
            params: {
              email: this.email.toLowerCase(),
              password: this.password,
              school_id: this.school.id,
            },
            success: (res: AxiosResponse) => {
              window.open(
                `${COMPANY}?token=${res.data.data.token}`,
                getBrowserType() === "Mozilla Firefox" ? "_self" : "_blank"
              );
            },
          });
        break;
    }
  }

  private togglePassword() {
    const password = document.getElementById("password");
    password?.setAttribute(
      "type",
      password?.getAttribute("type") === "password" ? "text" : "password"
    );
    document?.getElementById("password-eye")?.classList.toggle("bi-eye");
  }
}
